import React from "react"
import kebabCase from "lodash/kebabCase"
import { Helmet } from "react-helmet"
import { Link, graphql } from "gatsby"
import Layout from "../components/layout"
import '../styles/blog.css'
//import PropTypes from "prop-types"

const ArchivePage = ({
	data: {
		allPrismicPost: { group },
		site: {
			siteMetadata: { title },
		},
	},
}) => {
	const categoryObjects = group
		.filter(categoryObject => categoryObject.fieldValue !== 'about')
	return (
		<Layout>
			<Helmet title={title} />
			<div>
				<h1>Archive</h1>
				<ul>
					{categoryObjects.map(categoryObject => {
						return (
							<li key={categoryObject.fieldValue}>
								<Link to={`/category/${kebabCase(categoryObject.fieldValue)}`}>
									{categoryObject.fieldValue} ({categoryObject.totalCount})
								</Link>
							</li>
						)
					})}
				</ul>
			</div>
		</Layout>
	)
}

/*
ArchivePage.propTypes = {
	data: PropTypes.shape({
		allPrismicPost: PropTypes.shape({
			group: PropTypes.arrayOf(
				PropTypes.shape({
					fieldValue: PropTypes.string.isRequired,
					totalCount: PropTypes.number.isRequired,
				}).isRequired
			),
		}),
		site: PropTypes.shape({
			siteMetadata: PropTypes.shape({
				title: PropTypes.string.isRequired
			}),
		})
	}),
}*/

export default ArchivePage

export const pageQuery = graphql`
	query {
		site {
			siteMetadata {
				title
			}
		}
		allPrismicPost(limit: 2000) {
			group(field: data___categories___category___uid) {
				fieldValue
				totalCount
			}
		}
	}
`
